import { render, staticRenderFns } from "./OrderedItems.vue?vue&type=template&id=a3143b0c&scoped=true&"
import script from "./OrderedItems.vue?vue&type=script&lang=js&"
export * from "./OrderedItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderedItems.vue?vue&type=style&index=0&id=a3143b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3143b0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
